import { Answer, Link } from '../../types/api';

export interface CandidateState {
    application: Application;
    policyAgreeCheckbox: boolean;
    showPolicyCheckNotice: boolean;
    currentQuestion: Question | undefined;
    currentAnswer: Answer | undefined;
    retryAnswer: boolean;
    loadError: boolean;
}

export interface ApplicationLinks {
    self: Link;
    put_answer: Link;
    put_submit: Link;
    put_document: Link;
    put_accept_policy: Link;
}

export interface Application {
    id: string;
    vacancy: Vacancy;
    firstName: string;
    lastName: string;
    emailAddress: string;
    applicationState: ApplicationState;
    questions: Question[];
    answers: Answer[];
    documents: Document[];
    policyAccepted: boolean;
    _links?: ApplicationLinks;
}
export enum ApplicationState {
    CREATED = 'CREATED',
    INVITATION_SENT = 'INVITATION_SENT',
    APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED'
}

export interface Question {
    id: string;
    vacancyId: string;
    text: string;
}

export interface Document {
    id: string;
    applicationId: string;
    documentReference: string;
    documentName: string;
    _links?: DocumentLinks;
}

export interface DocumentLinks {
    self: Link;
}

export interface Vacancy {
    name: string;
    videoReference: string | null;
}



// WEBPACK FOOTER //
// ./src/scenes/candidate/types.ts